import type { ReactNode } from "react";
import { Plus } from "lucide-react";

interface PageContainerProps {
  wide?: boolean;
  children: ReactNode;
}

export function PageContainer({ wide, children }: PageContainerProps) {
  return (
    <div className={`p-6 ${wide ? "max-w-6xl" : "max-w-4xl"} mx-auto`}>
      {children}
    </div>
  );
}

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

export function PageHeader({ title, subtitle, buttonLabel, onButtonClick }: PageHeaderProps) {
  return (
    <div className="mb-6 flex items-center justify-between">
      <div>
        <h1 className="text-base font-semibold text-gray-900">{title}</h1>
        {subtitle && (
          <p className="text-xs text-gray-500">{subtitle}</p>
        )}
      </div>
      {buttonLabel && onButtonClick && (
        <button
          onClick={onButtonClick}
          className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-700 border border-gray-200 rounded px-2.5 py-1 transition-colors"
        >
          <Plus size={14} />
          {buttonLabel}
        </button>
      )}
    </div>
  );
}

interface PageEmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
}

export function PageEmptyState({ icon, title, description }: PageEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center text-gray-400 mb-3">
        {icon}
      </div>
      <h3 className="text-sm font-medium text-gray-900 mb-1">{title}</h3>
      <p className="text-xs text-gray-500">{description}</p>
    </div>
  );
}
